/* Cross-report glossary terms for the Insights info bubbles. These are the concepts every
 * report shares (overview/YoY framing, freshness). Each report spreads its own report-specific
 * field terms on top:
 *   fieldTips: { ...COMMON_TIPS, wo: "...", part: "...", ... }
 * The InsInfoTip component resolves a term via `text` OR (`termKey` + `glossary`). */
export const COMMON_TIPS = {
  ytd: "Year-to-date total for the current year, through the latest closed month.",
  prior_ytd: "The same year-to-date span one year ago, for comparison.",
  delta: "Change versus the prior period. The arrow and color show whether that move is favorable for this metric.",
  same_month: "The same calendar month one year ago.",
  data_through: "The date the underlying data is current through (from the last nightly refresh).",
  next_update: "When the next automatic overnight refresh is expected.",
};
